<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <!-- <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button> -->
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listPrintShow">打印</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button> -->
          <!-- <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button> -->
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="printShow">打印</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :disabled="true"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_userCode'"
                v-model="data.head['userCode']"
                code="userCode"
                name="用户编码"
                url="base/user/user/user/find/findPagination"
                :require="true"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onPopupClick="searchPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_userName'"
                v-model="data.head['userName']"
                code="userName"
                name="用户名称"
                default-value=""
                :require="true"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_robotCode'"
                v-model="data.head['robotCode']"
                code="robotCode"
                name="机器人编码"
                url="base/user/robot/robot/find/findPagination"
                :require="true"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onPopupClick="searchPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_robotName'"
                v-model="data.head['robotName']"
                code="robotName"
                name="机器人名称"
                default-value=""
                :require="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_inspectCode'"
                v-model="data.head['inspectCode']"
                code="inspectCode"
                name="检查项目编码"
                url="health/diagnosis/inspct/inspct/find/findPagination"
                :require="true"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :required="true"
                @onPopupClick="searchPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_inspectName'"
                v-model="data.head['inspectName']"
                code="inspectName"
                name="检查项目名称"
                default-value=""
                :require="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-datetime
                :ref="'input_inspectTime'"
                v-model="data.head['inspectTime']"
                code="inspectTime"
                name="检查时间"
                default-value=""
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_storeCode'"
                v-model="data.head['storeCode']"
                url="base/user/user/store/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="storeCode"
                name="门店编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeName'"
                v-model="data.head['storeName']"
                code="storeName"
                name="门店名称"
                default-value=""
                :require="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
          <el-tabs v-if="mode == 'edit' || mode == 'details'" v-model="active" style="margin: 0 10px;">
            <el-tab-pane label="体质" name="1">
              <div
                style="background: rgb(222, 238, 252); height: 132px; display: flex; justify-content: center;  align-items: center; padding:0 20px;"
              >
                <template v-for="item, index in data.body.inspectRecordItem">
                  <div v-if="item.inspectParamName.split('-')[1]!='血糖类型'" :key="index" class="blood">
                    <div style="display: flex;">
                      <div class="bloodItem">
                        <img src="@/assets/icon/Vector.png" alt="">
                      </div>
                      <div class="bloodItem" style="font-size: 26px;">
                        {{ item.inspectValue }}
                      </div>
                    </div>
                    <div style="display: flex;">
                      <div class="bloodItem">
                        {{ item.inspectParamName.split("-")[1] }}
                      </div>
                    </div>

                  </div>
                </template>
                <div class="jieguo">
                  <div class="jieguo-text">
                    {{ data.head.inspectTypeName }}
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-top: 20px;">
                <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px;" />
                <div>
                  指标走势
                </div>
              </div>
              <div style="height: 300px;">
                <Charts :x-axis-data="xAxis" :legend-data="legend" :series-data="chartsList" />
              </div>
            </el-tab-pane>
            <el-tab-pane label="方案" name="2">
              <div style="display: flex;">
                <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px;" />
                <div>
                  方案
                </div>
              </div>
              <div style="text-align: start;" v-html="schemeHtml.head.htmlContent" />

            </el-tab-pane>

          </el-tabs>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userCode'"
                      v-model="searcher['userCode']"
                      code="userCode"
                      name="用户编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userName'"
                      v-model="searcher['userName']"
                      code="userName"
                      name="用户名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotCode'"
                      v-model="searcher['robotCode']"
                      code="robotCode"
                      name="机器人编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_robotName'"
                      v-model="searcher['robotName']"
                      code="robotName"
                      name="机器人名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_inspectCode'"
                      v-model="searcher['inspectCode']"
                      code="inspectCode"
                      name="检查项目编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_inspectName'"
                      v-model="searcher['inspectName']"
                      code="inspectName"
                      name="检查项目名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_inspectTypeCode'"
                      v-model="searcher['inspectTypeCode']"
                      code="inspectTypeCode"
                      name="检查结果编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_inspectTypeName'"
                      v-model="searcher['inspectTypeName']"
                      code="inspectTypeName"
                      name="检查结果名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-datetime
                      :ref="'input_inspectTime'"
                      v-model="searcher['inspectTime']"
                      code="inspectTime"
                      name="检查时间"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-text
            code="code"
            name="编码"
            :edit="false"
          />
          <ik-column-text
            code="name"
            name="名称"
            :edit="false"
          />
          <ik-column-text
            code="userCode"
            name="用户编码"
            :edit="false"
          />
          <ik-column-text
            code="userName"
            name="用户名称"
            :edit="false"
          />
          <ik-column-text
            code="robotCode"
            name="机器人编码"
            :edit="false"
          />
          <ik-column-text
            code="robotName"
            name="机器人名称"
            :edit="false"
          />
          <ik-column-text
            code="inspectCode"
            name="检查项目编码"
            :edit="false"
          />
          <ik-column-text
            code="inspectName"
            name="检查项目名称"
            :edit="false"
          />
          <ik-column-text
            code="inspectTypeCode"
            name="检查结果编码"
            :edit="false"
          />
          <ik-column-text
            code="inspectTypeName"
            name="检查结果名称"
            :edit="false"
          />
          <ik-column-datetime
            code="inspectTime"
            name="检查结果名称"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <printIns
      ref="printRef"
      :print-data="data.head"
      :inspect-record-items="data.body.inspectRecordItem"
      :scheme-list="schemeList"
      :x-axis="xAxis"
      :legend="legend"
      :charts-list="chartsList"
      :scheme-data="schemeData"
      :scheme-html="schemeHtml"
    />
  </el-container>
</template>
<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormDatetime from '@/components/ik/form/input/IkFormDatetime'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnDatetime from '@/components/ik/table/ikColumn/IkColumnDatetime'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'
import { getSrc } from '@/utils/ik/oss/oss.js'
import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
import { getinspctparam, getScheme, getfindByCode } from '@/api/ik/data/health'
import Charts from './charts.vue'
import printIns from './printIns.vue'
import dayjs from 'dayjs'
export default {
  components: {
    // 表单组件
    IkFormText,
    IkFormDatetime,
    IkFormDataPopup,
    IkColumnText,
    IkPagination,
    IkColumnDatetime,
    Charts,
    printIns
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'health/diagnosis/inspct/inspectrecord',
      // Web路径
      webPath: 'inspect/InspectRecord',
      // 标识字段JSON
      jsonStr: {
        effectiveSign: '[{"key": "0", "value": "无效"}, {"key": "1", "value": "有效"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {
          inspectRecordItem: []
        }
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      },
      schemeList: [],
      chartsList: [],
      schemeData: {},
      schemeHtml: {
        head: {
          htmlContent: ''
        }
      },
      active: '1',
      inspectRecordItems: [],
      legend: [],
      xAxis: []
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页打印按钮点击
    async listPrintShow() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要打印的行!'
        })
      } else {
        await $this.get($this.activeRow.id, true)
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "userCode") {
        this.searcher["userCode"] = row.code
        this.searcher["userName"] = row.name
        this.searcher["userId"] = row.id
      } else if (code === "robotCode") {
        this.searcher["robotCode"] = row.code
        this.searcher["robotName"] = row.name
        this.searcher["robotId"] = row.id
      } else if (code === "inspectCode") {
        this.searcher["inspectCode"] = row.code
        this.searcher["inspectName"] = row.name
        this.searcher["inspectId"] = row.id
      } else if (code === 'inspectTypeCode') {
        this.searcher["inspectTypeCode"] = row.code
        this.searcher["inspectTypeName"] = row.name
        this.searcher["inspectTypeId"] = row.id
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "allergyDictionaryCode") {
        this.data.head["allergyDictionaryId"] = row.id
        this.data.head["allergyDictionaryCode"] = row.code
        this.data.head["allergyDictionaryName"] = row.name
        this.data.head["dicDescribe"] = row.dicDescribe
        this.data.head["pinyinCode"] = row.pinyinCode
      } else if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id, printShow) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
        $this.getInspctparams()
        $this.getFangan()
        if (printShow) {
          $this.printShow()
        }
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 启用词典
    listOpenBtn() {
      const $this = this
      postData(this.bgPath + "/do/enabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已启用!'
        })
      })
    },
    // 停用词典
    listCloseBtn() {
      const $this = this
      postData(this.bgPath + "/do/disabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已禁用!'
        })
      })
    },
    // 同步词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + "/do/syncdic", { "storeCode": $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    },
    getsrc(url) {
      if (url) {
        return getSrc('', url)
      }
    },
    getFangan() {
      console.log(this.data.head)

      const param = {
        data: {
          inspectTypeCode: this.data.head.inspectTypeCode,
          storeCode: this.data.head.storeCode,
          sexSign: typeof this.data.head.sexSign === 'number' ? this.data.head.sexSign : 1
        }
      }
      const param2 = {
        code: ''
      }
      getScheme(this.bgPath, param).then(res => {
        this.schemeData = res.data
        param2.code = res.data.contentInfoCode
        getfindByCode('', param2).then(res => {
          this.schemeHtml = res.data
        })
      })
    },
    getInspctparams() {
      const param = {
        data: {
          inspectCode: this.data.head.inspectCode,
          userCode: this.data.head.userCode
        }
      }
      getinspctparam(this.bgPath, param).then(res => {
        this.chartsList = []
        this.legend = []
        // 更好的响应式处理方式
        this.data.body.inspectRecordItem.forEach(element => {
          if (element.inspectParamName.split("-")[1] !== '血糖类型') {
            this.legend.push(element.inspectParamName.split("-")[1])
            this.chartsList.push({
              name: element.inspectParamName.split("-")[1],
              code: element.inspectParamCode.replace(element.inspectParamCode[0], element.inspectParamCode[0].toLowerCase()),
              type: 'line',
              data: [] // 初始化空数组
            })
          }
        })

        // 使用临时变量处理数据
        const tempXAxis = []
        const tempSeries = JSON.parse(JSON.stringify(this.chartsList)) // 深拷贝原结构

        res.data.forEach(element => {
          tempXAxis.push(element.inspectTime)
          tempSeries.forEach(e => {
            if (element[e.code]) {
              e.data.push(element[e.code])
            }
          })
        })

        // 使用Vue响应式更新
        this.xAxis = tempXAxis
        this.chartsList = tempSeries
      })
    },
    printShow() {
      this.data.head.age = dayjs().diff(this.data.head.birthDate, 'years')
      this.$refs.printRef.show = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
.blood {
  background: #fff;
  height: 60px;
  width: 150px;
  padding-top: 5px;
  margin: 0 30px;
}

.bloodItem {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ik-list-menu-btn {
  background-color: #1482f0;
  color: #FFFFFF;
}
.jieguo{
  background-image: url('../../../../assets/health/jieguo.png');
  background-position: center;
  background-repeat: no-repeat;
  height: 120px;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.jieguo-text{
  transform: rotate(-30deg);
  color: rgb(17, 10, 224);
}
</style>
